import { Button, Header, LoaderComponent } from 'components/common';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import axiosData from 'services/fetchInterceptor';
import PriceIcon from 'assets/icons/priceIcon.svg';
import { useAccount } from 'wagmi';
import { useContract, useListing, useMarketplace } from '@thirdweb-dev/react';
import { NATIVE_TOKEN_ADDRESS } from '@thirdweb-dev/sdk';
import BuyPropertyModal from 'components/common/BuyPropertyModal';
import BidOnPropertyModal from 'components/common/BidOnPropertyModal';
import ListPropertyModal from 'components/common/ListPropertyModal';
import EnterPricePropertyModal from 'components/common/EnterPricePropertyModal';
import UnlistPropertyModal from 'components/common/UnlistPropertyModal';
import propertyService from 'services/propertyService';

const PropertyDetails = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [ppt, setPpt] = useState<any>({});
  const [activeImage, setActiveImage] = useState<string>('');
  const [showBuyPropertyModal, setShowBuyPropertyModal] =
    useState<boolean>(false);
  const [showBidPropertyModal, setShowBidPropertyModal] =
    useState<boolean>(false);

  const [showListPropertyModal, setShowListPropertyModal] =
    useState<boolean>(false);

  const [showUnlistPropertyModal, setShowUnlistPropertyModal] =
    useState<boolean>(false);

  const [showListPricePropertyModal, setShowListPricePropertyModal] =
    useState<boolean>(false);

  const showBidModal = () => {
    setShowBidPropertyModal(true);
  };

  const showPriceModal = () => {
    setShowListPricePropertyModal(true);
  };

  /* Destructuring the useParams hook and the useAccount hook. */
  const { slug } = useParams();
  const { address } = useAccount();

  const marketplaceAddress = process.env.REACT_APP_MARKETPLACE_ADDRESS;
  const marketplace = useMarketplace(marketplaceAddress);

  // const contract = sdk.getContract('{{contract_address}}', 'marketplace');

  const fetchProperty = async (propertySlug: string) => {
    setLoading(true);
    const property = await propertyService.getProperty(propertySlug);
    // console.log(property);
    setPpt(property);
    setActiveImage(property.otherImages[0]);
    setLoading(false);
    return property;
  };

  const [listing, setListing] = useState<any[]>();
  // const { data: listing, isLoading } = useListing(marketplace, ppt.listingId);
  // const FetchOffers = async (listingId: number) => {
  //   let offers;
  //   try {
  //     offers = await marketplace?.getOffers(0);
  //     setListing(offers);
  //     return offers;
  //   } catch (error) {
  //     console.log(error);
  //   }
  //   // const firstOffer = offers?.[0];
  //   // console.log(offers, listingId);
  //   // console.log('firstOffer');
  //   return offers;
  // };

  // useEffect(() => {
  // console.log(ppt);
  // console.log('ppt');
  //   if (ppt.listed) {
  //     console.log('here');

  //     FetchOffers(ppt.listingId)
  //       .then((e) => {
  //         setListing(e);
  //         console.log(e);
  //         console.log('fetchProperty');
  //       })
  //       .catch((error) => {
  //         setLoading(false);
  //       });
  //   }
  // }, [ppt]);

  useEffect(() => {
    if (slug) {
      fetchProperty(slug)
        .then((e) => {
          console.log(e.title, 'Loading');
          // FetchOffers(e.listingId).then((offers) => {
          //   console.log(offers);
          //   console.log('qqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqq');
          // });
        })
        .catch((error) => {
          console.log(error);
          setLoading(false);
        });
    }
  }, [slug]);

  useEffect(() => {
    if (listing) {
      console.log(listing);
    }
  }, [listing]);

  const unlistAsset = async () => {
    setLoading(true);
    try {
      if (ppt.isDirectListing) {
        await marketplace?.direct.cancelListing(ppt.listingId);
      } else {
        await marketplace?.auction.cancelListing(ppt.listingId);
      }

      const unlist = await propertyService.unlistProperty(ppt?.propertyId);

      if (unlist) {
        setLoading(false);
        fetchProperty(ppt.slug);
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  function formatCurrency(value: any) {
    return Number(value).toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
    });
  }

  return (
    <>
      <div className="bg-[#121212] pb-16">
        <Header />

        {loading && <LoaderComponent />}

        <ListPropertyModal
          showModal={showListPropertyModal}
          setShowModal={setShowListPropertyModal}
          showPriceModal={showPriceModal}
        />

        <UnlistPropertyModal
          showModal={showUnlistPropertyModal}
          setShowModal={setShowUnlistPropertyModal}
          unlistAsset={unlistAsset}
        />

        <EnterPricePropertyModal
          showModal={showListPricePropertyModal}
          setShowModal={setShowListPricePropertyModal}
          property={ppt}
          fetchProperty={fetchProperty}
        />

        <BuyPropertyModal
          showModal={showBuyPropertyModal}
          setShowModal={setShowBuyPropertyModal}
          showBidModal={showBidModal}
          property={ppt}
        />

        <BidOnPropertyModal
          showModal={showBidPropertyModal}
          setShowModal={setShowBidPropertyModal}
          property={ppt}
        />

        <div className="container grid grid-cols-1 xl:grid-cols-2 gap-8 mx-auto px-4 md:px-8 xl:px-16 xl:mt-32">
          <div className="flex flex-col items-center">
            <div className="w-96 h-96 rounded">
              <img className="w-96 h-96 rounded-3xl" src={activeImage} alt="" />
            </div>

            <div className="mt-6 flex gap-3">
              {ppt.otherImages &&
              Array.isArray(ppt.otherImages) &&
              ppt.otherImages.length > 1
                ? ppt.otherImages.map((img: string) => (
                    <div
                      className={`${
                        img === activeImage
                          ? 'border-4 border-primary-2 rounded-xl'
                          : ''
                      } cursor-pointer p-2 rounded-xl`}
                      key={img}
                      onClick={() => {
                        setActiveImage(img);
                      }}
                      onKeyDown={() => {
                        setActiveImage(img);
                      }}
                      role="button"
                      tabIndex={0}
                    >
                      <img className="h-24 w-24 rounded-xl" src={img} alt="" />
                    </div>
                  ))
                : ''}
            </div>
          </div>
          <div>
            <div className="flex justify-between items-center">
              <p className="text-white text-5xl font-bold">{ppt.title}</p>

              {ppt.listed && (
                <>
                  <div className="flex">
                    <img className="mr-2" src={PriceIcon} alt="" />
                    <p className="text-white text-lg">{ppt.price}</p>
                  </div>
                  {!ppt.isDirectListing && (
                    <div className="flex">
                      <p className="text-white text-lg">Max:&nbsp;</p>
                      <img className="mr-2" src={PriceIcon} alt="" />
                      <p className="text-white text-lg">{ppt.maxPrice}</p>
                    </div>
                  )}
                </>
              )}
            </div>

            <div className="bg-black rounded-xl border border-primary-2 shadow-[0_4px_4px_rgba(0,0,0,0.25)] p-4 mt-8">
              <p className="text-white text-base">{ppt.description}</p>
            </div>

            <div className="mt-8">
              <div className="flex items-center mt-4">
                <p className="text-white/75">Property Type:</p>
                <p className="text-white text-lg ml-4">{ppt.type}</p>
              </div>
              <div className="flex items-center mt-4">
                <p className="text-white/75">Property Size:</p>
                <p className="text-white text-lg ml-4">{ppt.size} Sqm</p>
              </div>
              <div className="flex items-center mt-4">
                <p className="text-white/75">Property Address:</p>
                <p className="text-white text-lg ml-4">{ppt.address}</p>
              </div>
              <div className="flex items-center mt-4">
                <p className="text-white/75">External Link:</p>
                <p className="text-white text-lg ml-4">{ppt.externalLink}</p>
              </div>
              <div className="flex items-center mt-4">
                <p className="text-white/75">Property Owner:</p>
                <p className="text-white text-lg ml-4">{ppt.owner}</p>
              </div>
              <div className="flex items-center mt-4">
                <p className="text-white/75">Deed Year:</p>
                <p className="text-white text-lg ml-4">{ppt.deedYear}</p>
              </div>
            </div>

            <div className="flex  items-center mt-8">
              {address === ppt.owner ? (
                !ppt.listed ? (
                  <Button
                    type="submit"
                    className="px-12"
                    variant="primary"
                    // onClick={() => ListProperty(0.3, 0.4, ppt.tokenId)}
                    onClick={() => {
                      if (!address) {
                        return alert('Please connect wallet');
                      }
                      return setShowListPropertyModal(true);
                    }}
                  >
                    List
                  </Button>
                ) : (
                  <Button
                    type="submit"
                    onClick={() => {
                      if (!address) {
                        return alert('Please connect wallet');
                      }
                      return setShowUnlistPropertyModal(true);
                    }}
                    className="px-12"
                    variant="primary"
                  >
                    unList
                  </Button>
                )
              ) : (
                <Button
                  onClick={() => {
                    if (!address) {
                      return alert('Please connect wallet');
                    }
                    return setShowBuyPropertyModal(true);
                  }}
                  type="submit"
                  className="px-12"
                  variant="primary"
                >
                  Buy
                </Button>
              )}
              <Button
                type="submit"
                className="px-12 ml-4"
                variant="outline-primary"
              >
                Add To Add to Favorite
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PropertyDetails;

// propertyId: "property_c75013a3-1fb6-4486-b43a-a099efa7602e"
